import type { IPerson } from './getDisplayName';

export function getDisplayInitials(person: IPerson) {
    return (person.nameGiven ? person.nameGiven.charAt(0) : '') + person.nameFamily?.charAt(0);
}
